module.exports = __webpack_public_path__ + "media/images/official/about_yamori_odawara-4d6bf86c7690c4a01ea6a668080db3a2.png";